import _extends from "@babel/runtime/helpers/esm/extends";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
/**
 * @chineseName 评分
 * @subDescription m-ui组件 评分
 */
import * as React from 'react';
import RcRate from 'rc-rate';
import NormalFavoriteStarFill from '@m-ui/icons/NormalFavoriteStarFill';
import styled from '../_util/goober';
import Tooltip from '../tooltip';
import { ConfigContext } from '../config-provider';
var StyleRcRate = styled(RcRate, React.forwardRef)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n\n  ", "\n\n  ", "\n"])), function (props) {
  // 处理非高亮背景色
  if (props.bgColor) {
    return "\n      .".concat(props.prefixCls, "-star-zero,\n      .").concat(props.prefixCls, "-star-half {\n        .").concat(props.prefixCls, "-star-second {\n          color: ").concat(props.bgColor, ";\n        }\n      }");
  }
}, function (props) {
  // 处理图标间距
  if (props.iconSpacing || props.iconSpacing === 0) {
    return "\n      .".concat(props.prefixCls, "-star:not(:last-child) {\n        margin-right: ").concat(props.iconSpacing, "px;\n      }");
  }
}, function (props) {
  // 处理hover放大效果
  if (props.hoverScale) {
    return "\n      .".concat(props.prefixCls, "-star {\n        > div {\n          &:hover,\n          &:focus-visible {\n            transform: scale(").concat(props.hoverScale, ");\n          }\n        }\n      }");
  }
});
var Rate = /*#__PURE__*/React.forwardRef(function (_a, ref) {
  var prefixCls = _a.prefixCls,
    tooltips = _a.tooltips,
    color = _a.color,
    _a$style = _a.style,
    style = _a$style === void 0 ? {} : _a$style,
    props = __rest(_a, ["prefixCls", "tooltips", "color", "style"]);
  var characterRender = function characterRender(node, _ref) {
    var index = _ref.index;
    if (!tooltips) return node;
    return /*#__PURE__*/React.createElement(Tooltip, {
      title: tooltips[index]
    }, node);
  };
  var _React$useContext = React.useContext(ConfigContext),
    getPrefixCls = _React$useContext.getPrefixCls,
    direction = _React$useContext.direction;
  var ratePrefixCls = getPrefixCls('rate', prefixCls);
  return /*#__PURE__*/React.createElement(StyleRcRate, _extends({
    ref: ref,
    style: _extends({
      color: color
    }, style),
    characterRender: characterRender
  }, props, {
    prefixCls: ratePrefixCls,
    direction: direction
  }));
});
Rate.displayName = 'Rate';
Rate.defaultProps = {
  character: /*#__PURE__*/React.createElement(NormalFavoriteStarFill, null)
};
export default Rate;